<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1159.28 1044.64"
  >
    <path
      d="M960,28V994.07c-6.9,87.4-94.31,82.8-103.51-2.3"
      transform="translate(-380.36 -20.5)"
      fill="none"
      :stroke="umbrellaHandle"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="15"
    />
    <path
      d="M960,46.4l-50.53,58.52A863.25,863.25,0,0,0,721.91,473.47l-14.93,64-7.4-3.87a340.18,340.18,0,0,0-314.39.19l-4.83,2.53C380.36,265.74,639.86,46.4,960,46.4Z"
      transform="translate(-380.36 -20.5)"
      fill="#8bc5ff"
    />
    <path
      d="M1539.64,536.34a340.08,340.08,0,0,0-315.49-3.91l-10,5.06-1.5-7A1008.08,1008.08,0,0,0,1006,102.39l-46-56C1280.14,46.4,1539.64,265.74,1539.64,536.34Z"
      transform="translate(-380.36 -20.5)"
      fill="#8bc5ff"
    />
    <path
      d="M960,536.34"
      transform="translate(-380.36 -20.5)"
      fill="none"
      :stroke="umbrellaHandle"
      stroke-miterlimit="10"
    />
    <path
      d="M1214.17,537.49l-90-30.14a516,516,0,0,0-328.28.23L707,537.49l14.93-64A863.25,863.25,0,0,1,909.47,104.92L960,46.4l46,56a1008.08,1008.08,0,0,1,206.67,428.1Z"
      transform="translate(-380.36 -20.5)"
      fill="#b9d8ff"
    />
  </svg>
</template>

<script>
import { useTheme } from "vuetify";
export default {
  name: "UmbrellaIcon",
  setup() {
    const theme = useTheme();
    return { theme };
  },
  computed: {
    umbrellaHandle() {
      return this.theme.current.value.dark ? "#fff" : "#000";
    }
  }
};
</script>
